// Models
import { getDayIndexFromDayOfWeek } from "@ms/uno-utilities/lib/local/DateUtilities-temporal";
/**
 * Represents a weekly day.
 * @example Saturday of a week.
 */ export class WeeklyDay {
    resolveDateForPeriod(dateWithinPeriod) {
        // Get the target day of week (1=Monday, 7=Sunday in Temporal but we want 1=Sunday, 7=Saturday)
        const targetDayOfWeek = getDayIndexFromDayOfWeek(this.dayOfWeek) % 7 + 1;
        // Get current day of week (1=Sunday, 7=Saturday)
        const currentDayOfWeek = dateWithinPeriod.dayOfWeek % 7 + 1;
        // Calculate days to add/subtract to get to target day in same week
        const daysToAdd = targetDayOfWeek - currentDayOfWeek;
        // Add the calculated days to get the target day in the same week
        return dateWithinPeriod.add({
            days: daysToAdd
        });
    }
    constructor(dayOfWeek){
        this.dayOfWeek = dayOfWeek;
    }
}
